export class Helper {
    static parseObject(obj: Object): Object {

        return JSON.parse(JSON.stringify(obj))

    }
}